export const landHeaders = [
    {id: "Land--collectionPlace", label: "原典藏地"},
    {id: "Land--operator", label: "作業者"},
    {id: "Land--boxNumber", label: "箱號"},
    {id: "Land--number", label: "編號"},
    {id: "Land--landName", label: "土名（舊地段名）"},
    {id: "Land--landSerialNumber", label: "地番（地號）"},
    {id: "Land--abstract", label: "摘要"},
    {id: "Land--source", label: "現存資料"},
    {id: "Land--pawnRight", label: "胎典權記錄"},
    {id: "Land--plowingRight", label: "贌耕權記錄"},
    {id: "LandMark--landMarkNumber", label: "登記次序"},
    {id: "LandMark--cause", label: "登記（變更）原因"},
    {id: "LandMark--hasStartDate", label: "登記（變更）時間"},
    {id: "LandMark--landGrades", label: "則別"},
    {id: "LandMark--landCategory", label: "地目"},
    {id: "LandMark--landArea", label: "面積（甲）"},
    {id: "LandMark--landRent", label: "地租（圓）"},
    {id: "LandRights--landRightsNumber", label: "權利登記次序"},
    {id: "LandRights--hasStartDate", label: "權利登記（變更）時間"},
    {id: "LandRights--cause", label: "權利登記（變更）原因"},
    {id: "LandRights--hasOwner", label: "業主姓名"},
];
